import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import { submitEmail, submitPassword } from "./thunk";

export interface UsersState {
  status: "idle" | "reject" | "saving" | "saved";
  registeredEmail: string | null;
  error: string | null;
  fieldErrors: { [key: string]: string };
  resetPasswordToken: string | null;
}

const initialState: UsersState = {
  status: "idle",
  registeredEmail: null,
  error: null,
  fieldErrors: {},
  resetPasswordToken: ""
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setError: (state, action) => {
      const { questionId, error } = action.payload;
      state.fieldErrors[questionId] = error ? error : "";
    },
    setUserEmail: (state, action) => {
      const { email } = action.payload;
      state.registeredEmail = email;
    },
    setPasswordToken: (state, action) => {
      const { resetPasswordToken } = action.payload;
      state.resetPasswordToken = resetPasswordToken;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[usersSlice.name]
        };
      })
      .addCase(submitEmail.pending, (state) => {
        state.status = "saving";
      })
      .addCase(submitEmail.fulfilled, (state, action) => {
        state.status = "saved";
        state.registeredEmail = action.payload;
      })
      .addCase(submitEmail.rejected, (state, action) => {
        state.status = "reject";
        state.error = action.error.message;
      })
      .addCase(submitPassword.pending, (state) => {
        state.status = "saving";
      })
      .addCase(submitPassword.fulfilled, (state, action) => {
        state.status = "saved";
      })
      .addCase(submitPassword.rejected, (state, action) => {
        state.status = "reject";
        state.error = action.error.message;
      });
  }
});

export const { setStatus, setUserEmail, setError, setPasswordToken } =
  usersSlice.actions;
